var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_2732",
    "data-name": "Gruppe 2732",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.75,
    height: 45.684,
    viewBox: "0 0 52.75 45.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2678",
    "data-name": "Pfad 2678",
    d: "M38.612,33.855,33.2,34.96l-3.715-2.22L33.2,30.519l5.411,1.106.223-1.087-4.223-.862,3.6-2.153-.569-.952-3.6,2.153L35.281,24.6l-1.063-.319-1.588,5.291L28.96,31.762V27.486l3.727-4.079-.819-.749L28.96,25.84V21.647H27.85V25.84l-2.907-3.182-.819.749,3.726,4.079v4.277l-3.671-2.2-1.587-5.291-1.064.319,1.239,4.128-3.6-2.152-.57.952,3.6,2.152-4.223.863.222,1.087,5.412-1.106,3.715,2.221L23.61,34.961,18.2,33.855l-.222,1.086L22.2,35.8l-3.6,2.153.57.952,3.6-2.152-1.239,4.128,1.064.319,1.587-5.291,3.671-2.195v4.277l-3.726,4.079.819.749L27.85,39.64v4.193h1.11V39.64l2.908,3.182.819-.749L28.96,37.994V33.718l3.671,2.195L34.219,41.2l1.063-.319-1.239-4.128,3.6,2.153.569-.952-3.6-2.153,4.223-.863Z",
    transform: "translate(-2.03 -2.444)",
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2679",
    "data-name": "Pfad 2679",
    d: "M26.375,5.322l21.767,37.7H4.608Zm0-5.322L0,45.684H52.75Z",
    fill: "#ff7600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.885c87ae5d964a09c510536467822f4a.svg";
export { ForwardRef as ReactComponent };